export const getRoute = (route: string, baseRoute?: string): string => {
    baseRoute = baseRoute || '/creditBureau';
    return `${baseRoute}${route}`;
};

export const getAllRoutes = (baseRoute?: string): { [key: string]: string } => {
    // TODO: Add routes here
    return {
        root: getRoute('', baseRoute)
    };
};
